import { render } from "./FireFilter.vue?vue&type=template&id=10da060c&scoped=true"
import script from "./FireFilter.vue?vue&type=script&lang=ts"
export * from "./FireFilter.vue?vue&type=script&lang=ts"

import "./FireFilter.vue?vue&type=style&index=0&id=10da060c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10da060c"

export default script